export const singularityFieldConfig = {
  blackHoleMass: 0.4,
  raymarchLensing: 2.4,
  semanticInfluenceRadius: 42,
  opticalInfluenceRadius: 9.2,
} as const;
